module.exports = __webpack_public_path__ + "media/images/brand/favicon-white-a0283b0e59c9d83cf44709fa43d259b0.png";